module.exports = __webpack_public_path__ + "fonts/SofiaProBlack-Italic.0bc49c77.woff";